import config from "@/lib/config";
class AreaCheckAPI {
  url = config.areaCheck.url;
  apiKey = config.areaCheck.key;

  constructor(uid = "guest_web") {
    this.uid = uid;
  }

  async check(lat, lng) {
    // debug 広島の緯度経度
    // lat = 34.40458483926412;
    // lng = 132.45550318583173;
    const params = {
      api_key: this.apiKey,
      uid: this.uid,
      lat,
      lng,
    };
    const qs = new URLSearchParams(params);
    return await fetch(`${this.url}?${qs}`).then(async (res) => ({
      ok: res.ok,
      json: await res.json(),
    }));
  }
}

export default AreaCheckAPI;
